// extracted by mini-css-extract-plugin
export var measureBox = "_5y-0";